export default "/packs/images/coins~ec9a92df0fc4cb8bebb0cf9ac9a37bbc.png";